import HasID from "./HasID";

export interface Note extends HasID {
    body: string;
    entityType: number;
    entityId: number | string;
    created: Date;
    createdBy: string;
    deleted: Date | null;
    deletedBy: string | null;
    updated?: Date | null;
    updatedBy?: string | null;
    visibility: NoteVisibility;
    canView: boolean;
    pinned: boolean;
    parentNoteId?: number;
    activityType?: NoteActivityType;
}

export class Note implements Note {
    constructor(obj?: Note) {
        if (obj) Object.assign(this, obj);
    }
}

export enum NoteVisibility {
    AllUsers,
    Pharmacist,
    Internal
}

export enum NoteActivityType {
    PhoneCall,
    TextMessage,
    Electronic,
    Portal,
    Fax,
}
